import { render } from "./CatalogoConPrecio.vue?vue&type=template&id=990bf240"
import script from "./CatalogoConPrecio.vue?vue&type=script&lang=js"
export * from "./CatalogoConPrecio.vue?vue&type=script&lang=js"

import "./CatalogoConPrecio.vue?vue&type=style&index=0&id=990bf240&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__